/**
 * Shopify Customer Meta - Initialization
 * Initializes the Shopify API client and customer module instances
 */

(function() {
  'use strict';

  // Initialize Shopify Storefront Config from Liquid variables
  if (!window.ShopifyStorefrontConfig) {
    // This will be set by Liquid in the theme layout
    console.warn('ShopifyStorefrontConfig not found, waiting for initialization...');
  }

  let initAttempts = 0;
  const maxAttempts = 100;

  function initializeModules() {
    initAttempts++;

    // Check if all required classes are loaded
    if (!window.ShopifyStorefrontAPI || !window.ShopifyUtils || !window.ShopifyCustomer) {
      if (initAttempts < maxAttempts) {
        setTimeout(initializeModules, 50);
      } else {
        console.error('Failed to load Shopify module classes after', maxAttempts, 'attempts');
      }
      return;
    }

    // Check if config is available
    if (!window.ShopifyStorefrontConfig) {
      if (initAttempts < maxAttempts) {
        setTimeout(initializeModules, 50);
      } else {
        console.error('❌ ShopifyStorefrontConfig not available after', maxAttempts, 'attempts');
      }
      return;
    }

    // Initialize API client
    if (!window.shopifyAPI) {
      try {
        window.shopifyAPI = new window.ShopifyStorefrontAPI(window.ShopifyStorefrontConfig);
      } catch (error) {
        console.error('Error initializing Shopify API:', error);
        return;
      }
    }

    // Initialize Customer module
    if (!window.shopifyCustomer && window.shopifyAPI) {
      try {
        window.shopifyCustomer = new window.ShopifyCustomer(window.shopifyAPI);
      } catch (error) {
        console.error('Error initializing Shopify Customer:', error);
        return;
      }
    }

    // Initialize Auth module if available
    if (window.ShopifyAuth && !window.shopifyAuth && window.shopifyAPI) {
      try {
        window.shopifyAuth = new window.ShopifyAuth(window.shopifyAPI);
      } catch (error) {
        console.error('Error initializing Shopify Auth:', error);
      }
    }

    // Dispatch event to notify other scripts that modules are ready
    if (window.shopifyAPI && window.shopifyCustomer) {
      const event = new CustomEvent('shopify:modules:ready', {
        detail: {
          api: window.shopifyAPI,
          customer: window.shopifyCustomer,
          auth: window.shopifyAuth,
          utils: window.ShopifyUtils
        }
      });
      document.dispatchEvent(event);
    }
  }

  // Start initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeModules);
  } else {
    initializeModules();
  }
})();
